module.exports = __webpack_public_path__ + "img/plans3.15e30609.jpg";